// extracted by mini-css-extract-plugin
export default {"contact":"ContactInfo_contact__+jDJm","contactInfo":"ContactInfo_contactInfo__pTFrI","title":"ContactInfo_title__FB71j","description":"ContactInfo_description__2x+5q"};